import {EditToolbar} from './edit-toolbar';

export default EditToolbar;